import {
  OOS_OVERLAY_ADD_TO_CART_CLICK,
  OOS_OVERLAY_CLICK_ON_CLOSE,
  OOS_REPLACEMENT_PRODUCT_OVERLAY,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import { bindTrackingEvents } from 'shared/experiments/utils/tracking'

export default () => {
  const oosReplacementProductOverlay = getExperimentOnClient(
    OOS_REPLACEMENT_PRODUCT_OVERLAY
  )

  if (oosReplacementProductOverlay.isEnabled) {
    void activateExperiment(OOS_REPLACEMENT_PRODUCT_OVERLAY)

    bindTrackingEvents([
      {
        selector: '.o-OutOfStockOverlay .m-Modal__close',
        event: 'click',
        trackingEvent: OOS_OVERLAY_CLICK_ON_CLOSE,
      },
      {
        selector: '#h_OOSOverlayProductVariants #AddToCartButton',
        event: 'click',
        trackingEvent: OOS_OVERLAY_ADD_TO_CART_CLICK,
      },
    ])
  }
}
